/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500,
} from "../../types/pecegePayBilletController/PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid.ts";

function getPatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidUrl(
  courseFinPersonPaymentId: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/pecegepay/billet/cancel/${courseFinPersonPaymentId}` as const,
  };
  return res;
}

/**
 * @description Registra o cancelamento de um boleto pelo ID da parcela.
 * @summary Cancelar boleto por parcela
 * {@link /api/v1/pecegepay/billet/cancel/:courseFinPersonPaymentId}
 */
export async function patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid(
  courseFinPersonPaymentId: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"],
  params?: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidUrl(
      courseFinPersonPaymentId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
